import { useState } from "react";
import LayoutActividad from "../../../components/LayoutActividad";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit } from "@fortawesome/free-solid-svg-icons";
import { modulo13 } from "../../../routes/Module13";
import GuiaDocente from "../../../components/GuiaDocente";
import Sidebar from "../Sidebar";
import Imagen1 from "../../../images/modulo13/dialogo1.png";
import Imagen2 from "../../../images/modulo13/dialogo2.png";

import Card from "../../../components/Card";
import AudioPlayer from "../../../audioPlayer/AudioPlayer";
import Audio from "../../../audios/modulo13/Unidad3Actividad3.mp3";

const Actividad6 = () => {
  const [answers, setAnswers] = useState({
    ans1: { value: "", valid: "", correctValue: "servicios" },
    ans2: { value: "", valid: "", correctValue: "planificación" },
  });

  const infoUnidad = modulo13.content[2];
  const infoAct = modulo13.content[2].activities[3];
  const crumbs = [
    {
      title: modulo13.title,
      url: "/" + modulo13.url,
    },
    {
      title:
        modulo13.content.length === 1
          ? `${infoAct.name}`
          : `${infoUnidad.name} > ${infoAct.name}`,
      url: infoAct.path,
    },
  ];

  const pages = {
    titleNext: `${modulo13.content[2].name}: ${modulo13.content[2].activities[4].name}`,
    linkNext: `${modulo13.url}/${modulo13.content[2].path}/${modulo13.content[2].activities[4].path}`,
    titlePrev: `${modulo13.content[2].name}: ${modulo13.content[2].activities[2].name}`,
    linkPrev: `${modulo13.url}/${modulo13.content[2].path}/${modulo13.content[2].activities[2].path}`,
  };
  const metadata = {
    color: modulo13.color,
    title: `${modulo13.title} - ${infoAct.name}`,
    name: modulo13.title,
  };
  const validateAnswers = (event) => {
    event.preventDefault();
    let newAnswers = answers;
    Object.keys(newAnswers).forEach(
      (key) =>
        (newAnswers[key]["valid"] =
          answers[key]["correctValue"].toUpperCase() ===
          answers[key]["value"].toUpperCase()
            ? "is-valid"
            : "is-invalid")
    );
    setAnswers({ ...newAnswers });
  };
  const handleAnswers = (event, name) => {
    event.preventDefault();
    setAnswers({
      ...answers,
      [name]: { ...answers[name], value: event.target.value },
    });
  };

  return (
    <LayoutActividad
      pages={pages}
      crumbs={crumbs}
      sidebar={<Sidebar />}
      modulo={metadata}
    >
      <p>
        <small className={`c-${modulo13.color} hat-text`}>
          <FontAwesomeIcon icon={faEdit} /> Trabajamos con las palabras
        </small>
      </p>

      <h2 className="mb-5">{infoAct.name}</h2>
          <AudioPlayer track={Audio} />

      <ul>
        <li>
          Ahora completa el siguiente diálogo con algunas de las siguientes
          palabras:
        </li>
      </ul>

      <div className="row align-items-end justify-content-center">
        <div className="col-lg-10 col-12">
          <Card>
            <div className="d-flex justify-content-around">
              <div className="m-1">planificación</div>
              <div className="m-1">servicios</div>
              <div className="m-1">materiales</div>
              <div className="m-1">construcción</div>
            </div>
          </Card>
        </div>
        <div className="col-md-6 col-12">
          <Card>
            <p className="mb-0 fs-5">
              En mi época, teníamos{" "}
              <input
                type="text"
                className={
                  "form-control form-control-sm d-inline-block w-200 " +
                  answers.ans1.valid
                }
                value={answers.ans1.value}
                onChange={(event) => handleAnswers(event, "ans1")}
              />{" "}
              de almacenamiento en la ciudad para guardar alimentos para
              momentos de escasez.
            </p>
          </Card>
          <img src={Imagen1} className="img-fluid" alt="Peruanos" />
        </div>
        <div className="col-md-6 col-12">
          <Card>
            <p className="mb-0 fs-5">
              En la época colonial, incluíamos la construcción de murallas en la{" "}
              <input
                type="text"
                className={
                  "form-control form-control-sm d-inline-block w-200 " +
                  answers.ans2.valid
                }
                value={answers.ans2.value}
                onChange={(event) => handleAnswers(event, "ans2")}
              />{" "}
              de las ciudades. Lo hacíamos para protegernos de los ataques
              piratas.
            </p>
          </Card>
          <img src={Imagen2} className="img-fluid mb-4" alt="Peruanos" />
        </div>
      </div>

      <div className="row my-4">
        <div className="col-12">
          <button
            className={`btn float-end btn-${modulo13.color}`}
            onClick={validateAnswers}
          >
            Enviar respuestas
          </button>
        </div>
      </div>

      <GuiaDocente>
        <ul>
          <li>
            Lea la primera indicación: Ahora completa el siguiente diálogo con
            algunas de las siguientes palabras: planificación, servicios,
            materiales, construcción. Dé un tiempo para que 
            realicen la actividad. Pida que lean en voz alta
            el diálogo. Cierre la actividad reflexionando acerca de lo que dicen
            los personajes:
            <ul>
              <li>
                <i>
                  “¿Qué tipo de información nos dan acerca de la ciudad?
                  (Posible respuesta: En ambos casos se construye para cubrir
                  una necesidad de los pobladores. José Yupanqui nos habla del
                  almacenamiento de comida e Inés de Orbegoso de las murallas).”
                </i>
              </li>
            </ul>
          </li>
        </ul>
      </GuiaDocente>
    </LayoutActividad>
  );
};

export default Actividad6;
